import React, { useState } from "react";
import {
    Dialog as MuiDialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    styled,
    FormControlLabel,
    Radio,
    FormControl,
    RadioGroup,
    Divider,
} from "@mui/material";
import { ReactComponent as Warning } from "assets/img/warningImage.svg";
import { FormFieldContainer } from "components/ui/FormField";

const Dialog = styled(MuiDialog)(({ theme }) => ({
    "& .MuiDialog-container": {
        "& .MuiDialog-paper": {
            maxWidth: "780px",
            padding: "8px 15px",
        },
    },
}));

const AddressVerificationModal = ({
    open,
    currentAddress = null,
    suggestedAddress = null,
    onContinue,
    onEdit,
}) => {
    const [selectedAddress, setSelectedAddress] = useState("enteredAddress");

    const handleContinue = () => {
        const addressToUse =
            selectedAddress === "enteredAddress" ? currentAddress : suggestedAddress;
        onContinue(addressToUse);
    };

    return (
        <Dialog open={open} onClose={onEdit}>
            <DialogTitle>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Warning width={48} height={48} />
                    <Typography
                        sx={{ fontSize: "26px", fontWeight: 700, color: "#0f172a" }}
                    >
                        Please verify your address
                    </Typography>
                </Box>
                <Typography variant="body1">
                  Please choose the version of the address you want to use or click “edit address” to make changes.
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ px: 4 }}>
                <FormControl>
                    <RadioGroup
                        name="selectedAddress"
                        value={selectedAddress}
                        onChange={(e) => setSelectedAddress(e.target.value)}
                    >
                        <FormFieldContainer
                            heading="You Entered:"
                            headingSx={{ px: 4 }}
                            gap={0}
                            fields={[
                                <FormControlLabel
                                    value="enteredAddress"
                                    control={<Radio />}
                                    label={<AddressContainer address={currentAddress} />}
                                />,
                            ]}
                        />
                        <Divider sx={{ my: 1 }} />

                        <FormFieldContainer
                            heading="Suggested Address:"
                            headingSx={{ px: 4 }}
                            gap={0}
                            fields={[
                                <FormControlLabel
                                    value="suggestedAddress"
                                    control={<Radio disabled={!suggestedAddress} />}
                                    label={<AddressContainer address={suggestedAddress} />}
                                />,
                            ]}
                        />
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleContinue} variant="contained" fullWidth>
                    Continue with this address
                </Button>
                <Button onClick={onEdit} variant="outlined" fullWidth>
                    Edit address
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddressVerificationModal;

const AddressContainer = ({ address }) => {
    if (!address) return "-";
    return (
        <Box>
            <Typography>{address?.primaryLine}</Typography>
            <Typography>{address?.secondaryLine}</Typography>
            <Typography>
                {address?.city}, {address?.state} {address?.zipCode}
            </Typography>
        </Box>
    );
};
